// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3rU1c","file":"styles_file__3TMx_"};